import Model from '@/shared/models/PlanProposal'
import i18n from '@/plugins/i18n'

export default class PlanProposal extends Model {
    get tableColumns() {
        return [
            {
                text: '#',
                value: 'id',
                sortable: false,
            },
            {
                text: i18n.t('resources.plan-proposal.attributes.customer'),
                value: 'customer',
                sortable: false,
            },
            {
                text: i18n.t('resources.plan-proposal.attributes.plan'),
                value: 'plan_package',
                sortable: false,
            },
            {
                text: i18n.t('resources.plan-proposal.attributes.totalPrice'),
                value: 'totalPrice',
                sortable: false,
            },
            {
                text: i18n.t('resources.plan-proposal.attributes.finalPrice'),
                value: 'finalPrice',
                sortable: false,
            },
            {
                text: i18n.t('resources.plan-proposal.attributes.requestedAt'),
                value: 'formattedRequestedAt',
                sortable: false,
            },
            {
                text: i18n.t('resources.plan-proposal.attributes.approvedAt'),
                value: 'formattedApprovedAt',
                sortable: false,
            },
            {
                text: i18n.t('resources.plan-proposal.attributes.rejectedAt'),
                value: 'formattedRejectedAt',
                sortable: false,
            },
            {
                text: i18n.t('resources.plan-proposal.attributes.expireAt'),
                value: 'formattedExpireAt',
                sortable: false,
            },
            {
                text: 'Ações',
                value: 'action',
                sortable: false,
                width: 150,
                align: 'end',
            },
        ]
    }

    get actions() {
        return [
            {
                type: 'show',
                to: {
                    name: 'plan-proposal.show',
                    params: { id: this.id },
                },
            },
            {
                type: 'delete',
                hide: !this.isDeleted,
            },
            {
                type: 'restore',
                hide: this.isDeleted,
            },
        ]
    }
}
